import { useEffect } from 'react';

export function ShadowDomGTM() {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    function shadowDomEvent(event: MouseEvent) {
      if ('composed' in event && typeof event.composedPath === 'function') {
        // it can be elements other than HTMLLinkElement but this is a hack for avoiding // @ts-ignore
        const path = event.composedPath() as HTMLLinkElement[];
        const targetElement = path[0];

        const inputElement = path.find(
          (node) =>
            node.localName === 'button' ||
            node.localName === 'a' ||
            node.localName === 'input' ||
            node.localName === 'select' ||
            node.localName === 'textarea'
        );

        const isShadowDom = path.length
          ? path.filter((i) => !targetElement.shadowRoot && !!i.shadowRoot)
              .length > 0
          : false;

        if (isShadowDom && inputElement) {
          window?.dataLayer?.push({
            event: 'gtm.click',
            'gtm.element': inputElement,
            'gtm.elementId': inputElement.id || '',
            'gtm.elementClasses': inputElement.className || '',
            'gtm.elementUrl': inputElement.href || '',
            'gtm.elementTarget': inputElement,
            'gtm.originalEvent': event,
            inShadowDom: true,
          });
        }
      }
    }

    // Mount Shadow DOM Event Tracker
    document.addEventListener('click', shadowDomEvent, true); // true is shadow dom capture

    return () => {
      document.removeEventListener('click', shadowDomEvent, true); // true is shadow dom capture
    };
  }, []);

  return null;
}
